import axios from 'axios';
import store from '../store';
import {unByKey} from 'ol/Observable';
import { Image } from 'ol/layer';

const getFeatureInfo = function (map) {
  this.map = map;
  this.results = null;
  this.urls = null;
  this._listeners = {
    single: null,
  }
  this.enable();
};

getFeatureInfo.prototype.enable = function () {
  console.log("ENABLE")
  this.isDisabled = false;
  this._listeners.single = this.map.on('singleclick', this._handleClick.bind(this));
};

getFeatureInfo.prototype.disable = function () {
  this.isDisabled = true;
  unByKey(this._listeners.single)
};

getFeatureInfo.prototype._handleClick = function (e) {
  console.log('clickevent', e)
  store.commit('featureInfo/CLEAR_QUERY');
  this.urls = [];
  this.results = [];
  const viewResolution = this.map.getView().getResolution();
  console.dir(this.map);
  const mapProj = this.map.getView().getProjection().getCode();
  this.map.getLayers().forEach((layer) => {
    console.log(layer.id, layer);
    if (!store.getters.GET_LAYERS[layer.id] || !store.getters.GET_LAYERS[layer.id].colparams) {
      return;
    }

    if (layer instanceof GOX.Layer.WMS) {
      console.dir(layer);
      const layerProj = layer.getSource().getProjection().getCode();
      console.log("LAY PROJ", layerProj)
      const url = {
        title: store.getters.GET_LAYERS[layer.id].title,
        url: layer.getSource().getFeatureInfoUrl(
          e.coordinate, viewResolution, mapProj,
          {
            INFO_FORMAT: 'application/json',
            BUFFER: 20,
            FEATURE_COUNT: 50,
            BBOX: GOX.Transform(this.map.getExtent(), mapProj, layer.getSource().getProjection().getCode()),
          },
        )
      }

      this.urls.push(url);
    }
  });

  console.dir(this.urls);

  axios.all(this.urls.map( async l => {
    return {
      resp: await axios.get(l.url, {
        withCredentials: true,
      }),
      title: l.title
    }
  }))
    .then(axios.spread((...res) => {
      // all requests are now complete
      res.forEach((infoResult) => {
        let result = {title: infoResult.title, ...infoResult.resp.data};
        console.log("MERGED RESULT")
        console.dir(result)
        this.results.push(result);
      });

      console.dir(this.results);
      store.dispatch('featureInfo/UPDATE_QUERY_RESULTS', this.results);
      this.map.dispatchEvent({
        type: 'info-click', coordinate: e.coordinate
      })
    }));
};


export default getFeatureInfo;
